import { apiClient, apiFetch } from "@/lib/api-client";

export interface MyShopProfile {
  seller: {
    id: string;
    business_name: string;
    market_id: string;
    pavilion_number: string;
    entrance_hint: string | null;
    phone_e164: string;
    whatsapp_phone_e164: string | null;
    telegram_handle: string | null;
    lat: string | null;
    lng: string | null;
    verification_status: "pending" | "verified" | "rejected" | "suspended";
    vacation_mode: boolean;
    vacation_mode_since: string | null;
  };
  profile: {
    operating_hours: string | null;
    languages: string[];
    warranty: boolean;
    years_in_business: number | null;
    district: string | null;
    market_label: string | null;
    rating: string | null;
    reviews_count: number;
  };
  contact_channels: Array<{
    channel: string;
    value: string;
    enabled: boolean;
    click_count_7d: number;
  }>;
  completeness: {
    location_set: boolean;
    hours_set: boolean;
    contacts_set: boolean;
    percent: number;
  };
}

export interface MyShopProfileUpdate {
  business_name?: string;
  pavilion_number?: string;
  entrance_hint?: string;
  whatsapp_phone_e164?: string;
  telegram_handle?: string;
  lat?: string;
  lng?: string;
  operating_hours?: string;
  languages?: string[];
  warranty?: boolean;
  years_in_business?: number;
  district?: string;
}

export interface SellerOverview {
  shop: {
    business_name: string;
    market_label: string | null;
    verification_status: "pending" | "verified" | "rejected" | "suspended";
    vacation_mode: boolean;
  };
  catalog: {
    total: number;
    draft: number;
    pending_approval: number;
    active: number;
    rejected: number;
    hidden_by_seller: number;
    out_of_stock: number;
  };
  completeness: {
    location_set: boolean;
    hours_set: boolean;
    contacts_set: boolean;
    percent: number;
  };
  buyer_interest: {
    contact_taps_7d: number;
    by_channel: Record<string, number>;
  };
}

export function getMyShopProfile(): Promise<MyShopProfile> {
  return apiClient.get<MyShopProfile>("/sellers/me/profile");
}

export function updateMyShopProfile(
  body: MyShopProfileUpdate,
): Promise<MyShopProfile> {
  return apiFetch<MyShopProfile, MyShopProfileUpdate>({
    method: "PATCH",
    path: "/sellers/me/profile",
    body,
  });
}

export function getSellerOverview(): Promise<SellerOverview> {
  return apiClient.get<SellerOverview>("/sellers/me/overview");
}

export function phoneChangeSend(body: {
  new_phone_e164: string;
}): Promise<{ retry_after_seconds: number }> {
  return apiClient.post<{ retry_after_seconds: number }, { new_phone_e164: string }>(
    "/sellers/me/phone/change/send",
    body,
  );
}

export function phoneChangeVerify(body: {
  otp: string;
}): Promise<{ phone_e164: string }> {
  return apiClient.post<{ phone_e164: string }, { otp: string }>(
    "/sellers/me/phone/change/verify",
    body,
  );
}
